const attrs = {
  name: "New campaign",
  links: "",
  field_values: {},
  history: [],
  url_encoded: false,
};

const options = {
  parentType: "spaces",
  parentKey: "space_id",
};

export default {
  generic: {
    attrs,
    options,
  },
};
